import React from 'react'

export const IconCopy = (props= {}) => {
	const { size= 20, imgSize= 20, fill="white" } = props
	return (
		<svg xmlns="http://www.w3.org/2000/svg"
				 width={`${size}px`}
				 height={`${size}px`}
				 viewBox={`0 0 ${imgSize} ${imgSize}`}
				 fill="none"
		>
			<path
				d="M4.5835 5.83333H3.3335V17.5H13.3335V16.25H4.5835V5.83333ZM6.66683 2.5V14.1667H16.6668V2.5H6.66683ZM15.4168 12.9167H7.91683V3.75H15.4168V12.9167Z"
				fill={fill}
			/>
		</svg>
	)
}